// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/question-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
	background: #EBF2F3;
	font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
	height: 63px;
	position: relative;
	z-index: 4;
}
#header-inner {
	margin: 0 auto;
	overflow: hidden;
	padding: 0 320px 0 20px;
    position: relative;
    height: 100%;
}
.max-width #header-inner {
	max-width: 1120px;
	min-width: 780px;
}
.start-page.max-width #header-inner {
	max-width: 1140px;
	min-width: 800px;
}
.header-logo-block {
	float: left;
	margin-right: 15px;
	position: relative;
	white-space: nowrap;
}
.header-logo-block .header-logo-block-util {
	display: inline-block;
	height: 62px;
	margin-left: -1px;
	vertical-align: middle;
	width: 1px;
}
.logo {
	display: inline-block;
	font-size: 24px;
	font-family: OpenSans-Semibold, sans-serif;
	line-height: 62px;
	margin-right: 10px;
	min-width: 222px;
	overflow: hidden;
	vertical-align: middle;
	white-space: nowrap;
}
.logo-text {
	color: #ffffff;
	display: inline-block;
	margin-right: 7px;
	max-width: 235px;
	overflow: hidden;
	position: relative;
	vertical-align: top;
}
.logo:hover, .logo:visited, .logo:active, .logo:link {
	text-decoration: none;
}
.logo-color {
	color: #2fc6f7;
	display: inline-block;
}
#logo_24_img {
    margin-top: 0px;
}
.user-logout a {
	text-decoration: none;
}
.user-logout a:hover {
	text-decoration: underline;
}
.user-block {
	cursor: pointer;
	height: 63px;
	padding: 0 0 0 18px;
	position: relative;
	float: left;
	right: 74px;
	top: 0;
	width: auto;
}
.user-block-before {
	display: none;
}
.user-block-active {
	background: #3d4653 !important;
}
.user-img {
	border-radius: 50%;
	display: inline-block;
	height: 38px;
	margin: 11px 15px 14px 0;
	vertical-align: middle;
	width: 38px;
}

.user-name {
	color: #605252;
	display: inline-block;
	font-size: 14px;
	font-weight: bold;
	margin-top: -2px;
	min-width: 100px;
	overflow: hidden;
	padding-right: 20px;
	position: relative;
	text-overflow: ellipsis;
	vertical-align: middle;
	white-space: nowrap;
}
.user-name:after {
	content: '';
	height: 3px;
	margin-top: -2px;
	right: 0;
	top: 50%;
	position: absolute;
	width: 7px;
}
.help-block {
	cursor: pointer;
	display: block;
	height: 63px;
	position: absolute;
	top: 0;
	width: 63px;
	border-left: 1px solid #848c95;
	overflow: hidden;
}
.help-block-icon {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
	background-color: rgb(60, 157, 191);
	background-repeat: no-repeat;
    background-position: 10px 10px;
    background-size: 15px 15px;
    border-radius: 50%;
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0), 0 0 0 0 #3c9dbf;
    height: 34px;
    left: 15px;
    top: 15px;
    position: absolute;
    width: 34px;
    transition: all 0.25s linear;
}
.help-icon-border {
	border: 5px solid #78808b;
	border-radius: 50%;
	box-sizing: border-box;
	height: 30px;
	left: 18px;
	top: 15px;
	position: absolute;
	width: 30px;
	transition: border-width 0.2s linear;
}
.help-block:hover .help-icon-border {
	background-color: #2fc7f7;
    box-shadow: 0 0 0 30px #2fc7f7;
}
.help-block:hover .help-block-icon {
	background-color: #2fc7f7;
	border: 1px solid #fff;
	top: 14px;
	left: 14px;
}
.help-block {
	right: 14px;
}
#menu-popup-user-menu{
	width: 150px;
    background: rgb(255, 255, 255);
    padding: 15px 10px;
    font-size: 12px;
    box-shadow: 0 7px 21px #ddd, 0 -1px 6px 0 #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/components/Container/TopBar/style.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,wDAAwD;CACxD,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;IACpB,kBAAkB;IAClB,YAAY;AAChB;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,0CAA0C;CAC1C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;IACI,eAAe;AACnB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,MAAM;CACN,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,wBAAwB;CACxB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,WAAW;CACX,gBAAgB;CAChB,QAAQ;CACR,QAAQ;CACR,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,8BAA8B;CAC9B,gBAAgB;AACjB;AACA;CACC,6DAAgD;CAChD,mCAAmC;CACnC,4BAA4B;IACzB,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAElB,6DAA6D;IAC7D,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,WAAW;IAEX,4BAA4B;AAChC;AACA;CACC,yBAAyB;CACzB,kBAAkB;CAGlB,sBAAsB;CACtB,YAAY;CACZ,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,WAAW;CAEX,oCAAoC;AACrC;AACA;CACC,yBAAyB;IAEtB,8BAA8B;AAClC;AACA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,SAAS;CACT,UAAU;AACX;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;IACT,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,8CAA8C;AAClD","sourcesContent":["#header {\r\n\tbackground: #EBF2F3;\r\n\tfont-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n\theight: 63px;\r\n\tposition: relative;\r\n\tz-index: 4;\r\n}\r\n#header-inner {\r\n\tmargin: 0 auto;\r\n\toverflow: hidden;\r\n\tpadding: 0 320px 0 20px;\r\n    position: relative;\r\n    height: 100%;\r\n}\r\n.max-width #header-inner {\r\n\tmax-width: 1120px;\r\n\tmin-width: 780px;\r\n}\r\n.start-page.max-width #header-inner {\r\n\tmax-width: 1140px;\r\n\tmin-width: 800px;\r\n}\r\n.header-logo-block {\r\n\tfloat: left;\r\n\tmargin-right: 15px;\r\n\tposition: relative;\r\n\twhite-space: nowrap;\r\n}\r\n.header-logo-block .header-logo-block-util {\r\n\tdisplay: inline-block;\r\n\theight: 62px;\r\n\tmargin-left: -1px;\r\n\tvertical-align: middle;\r\n\twidth: 1px;\r\n}\r\n.logo {\r\n\tdisplay: inline-block;\r\n\tfont-size: 24px;\r\n\tfont-family: OpenSans-Semibold, sans-serif;\r\n\tline-height: 62px;\r\n\tmargin-right: 10px;\r\n\tmin-width: 222px;\r\n\toverflow: hidden;\r\n\tvertical-align: middle;\r\n\twhite-space: nowrap;\r\n}\r\n.logo-text {\r\n\tcolor: #ffffff;\r\n\tdisplay: inline-block;\r\n\tmargin-right: 7px;\r\n\tmax-width: 235px;\r\n\toverflow: hidden;\r\n\tposition: relative;\r\n\tvertical-align: top;\r\n}\r\n.logo:hover, .logo:visited, .logo:active, .logo:link {\r\n\ttext-decoration: none;\r\n}\r\n.logo-color {\r\n\tcolor: #2fc6f7;\r\n\tdisplay: inline-block;\r\n}\r\n#logo_24_img {\r\n    margin-top: 0px;\r\n}\r\n.user-logout a {\r\n\ttext-decoration: none;\r\n}\r\n.user-logout a:hover {\r\n\ttext-decoration: underline;\r\n}\r\n.user-block {\r\n\tcursor: pointer;\r\n\theight: 63px;\r\n\tpadding: 0 0 0 18px;\r\n\tposition: relative;\r\n\tfloat: left;\r\n\tright: 74px;\r\n\ttop: 0;\r\n\twidth: auto;\r\n}\r\n.user-block-before {\r\n\tdisplay: none;\r\n}\r\n.user-block-active {\r\n\tbackground: #3d4653 !important;\r\n}\r\n.user-img {\r\n\tborder-radius: 50%;\r\n\tdisplay: inline-block;\r\n\theight: 38px;\r\n\tmargin: 11px 15px 14px 0;\r\n\tvertical-align: middle;\r\n\twidth: 38px;\r\n}\r\n\r\n.user-name {\r\n\tcolor: #605252;\r\n\tdisplay: inline-block;\r\n\tfont-size: 14px;\r\n\tfont-weight: bold;\r\n\tmargin-top: -2px;\r\n\tmin-width: 100px;\r\n\toverflow: hidden;\r\n\tpadding-right: 20px;\r\n\tposition: relative;\r\n\ttext-overflow: ellipsis;\r\n\tvertical-align: middle;\r\n\twhite-space: nowrap;\r\n}\r\n.user-name:after {\r\n\tcontent: '';\r\n\theight: 3px;\r\n\tmargin-top: -2px;\r\n\tright: 0;\r\n\ttop: 50%;\r\n\tposition: absolute;\r\n\twidth: 7px;\r\n}\r\n.help-block {\r\n\tcursor: pointer;\r\n\tdisplay: block;\r\n\theight: 63px;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\twidth: 63px;\r\n\tborder-left: 1px solid #848c95;\r\n\toverflow: hidden;\r\n}\r\n.help-block-icon {\r\n\tbackground: url(images/question-2.png) no-repeat;\r\n\tbackground-color: rgb(60, 157, 191);\r\n\tbackground-repeat: no-repeat;\r\n    background-position: 10px 10px;\r\n    background-size: 15px 15px;\r\n    border-radius: 50%;\r\n    -webkit-box-shadow: 0 0 0 1px rgba(255, 255, 255, 0), 0 0 0 0 #3c9dbf;\r\n    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0), 0 0 0 0 #3c9dbf;\r\n    height: 34px;\r\n    left: 15px;\r\n    top: 15px;\r\n    position: absolute;\r\n    width: 34px;\r\n    -webkit-transition: all 0.25s linear;\r\n    transition: all 0.25s linear;\r\n}\r\n.help-icon-border {\r\n\tborder: 5px solid #78808b;\r\n\tborder-radius: 50%;\r\n\t-webkit-box-sizing: border-box;\r\n\t-moz-box-sizing: border-box;\r\n\tbox-sizing: border-box;\r\n\theight: 30px;\r\n\tleft: 18px;\r\n\ttop: 15px;\r\n\tposition: absolute;\r\n\twidth: 30px;\r\n\t-webkit-transition: border-width 0.2s linear;\r\n\ttransition: border-width 0.2s linear;\r\n}\r\n.help-block:hover .help-icon-border {\r\n\tbackground-color: #2fc7f7;\r\n    -webkit-box-shadow: 0 0 0 0px rgba(255, 255, 255, 1), 0 0 0 30px #2fc7f7;\r\n    box-shadow: 0 0 0 30px #2fc7f7;\r\n}\r\n.help-block:hover .help-block-icon {\r\n\tbackground-color: #2fc7f7;\r\n\tborder: 1px solid #fff;\r\n\ttop: 14px;\r\n\tleft: 14px;\r\n}\r\n.help-block {\r\n\tright: 14px;\r\n}\r\n#menu-popup-user-menu{\r\n\twidth: 150px;\r\n    background: rgb(255, 255, 255);\r\n    padding: 15px 10px;\r\n    font-size: 12px;\r\n    box-shadow: 0 7px 21px #ddd, 0 -1px 6px 0 #ddd;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
